import * as React from "react";
const AddressIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 39 40"
        fill="none"
        {...props}
    >
        <path
            fill="#fff"
            d="M13.14 15.158c.3 8.478 12.494 8.478 12.796 0-.302-8.474-12.492-8.477-12.795 0Z"
        />
        <path
            fill="#fff"
            d="M19.538.625a18.687 18.687 0 0 0-1.892.095 18.586 18.586 0 0 0-1.875.28 19.279 19.279 0 0 0-3.622 1.104 19.664 19.664 0 0 0-1.713.812 18.569 18.569 0 0 0-1.624.976A19.685 19.685 0 0 0 7.29 5.023a20.166 20.166 0 0 0-1.404 1.274 19.21 19.21 0 0 0-1.272 1.406c-.2.245-.4.494-.584.748a19.17 19.17 0 0 0-2.332 4.117 20.198 20.198 0 0 0-.642 1.785 19.359 19.359 0 0 0-.837 5.61c1.062 25.659 37.579 25.652 38.636 0a18.736 18.736 0 0 0-.095-1.894 18.62 18.62 0 0 0-.28-1.876 19.002 19.002 0 0 0-1.104-3.626 19.18 19.18 0 0 0-.812-1.714c-.15-.278-.3-.555-.467-.826a24.039 24.039 0 0 0-.507-.8 20.81 20.81 0 0 0-.546-.776c-.188-.254-.383-.5-.584-.748a19.281 19.281 0 0 0-2.676-2.681c-.244-.202-.494-.4-.747-.583a19.616 19.616 0 0 0-2.4-1.523 19.689 19.689 0 0 0-1.712-.812 20.143 20.143 0 0 0-1.784-.642A19.867 19.867 0 0 0 22.37.837a19.665 19.665 0 0 0-2.83-.212Zm-.02 33.582c-.625-.729-9.289-10.289-9.4-19.048 0-.154 0-.31.01-.463.01-.154.02-.31.034-.463a8.71 8.71 0 0 1 .135-.916c.03-.152.063-.3.1-.453.037-.153.079-.3.124-.446a8.374 8.374 0 0 1 .311-.872 9.394 9.394 0 0 1 1.42-2.375c.099-.12.2-.236.3-.351.1-.115.211-.226.32-.336a9.147 9.147 0 0 1 .685-.62c.12-.094.24-.192.365-.284a9.203 9.203 0 0 1 .769-.515 7.619 7.619 0 0 1 .814-.437 9.867 9.867 0 0 1 .854-.355 8.772 8.772 0 0 1 1.338-.37c.152-.027.3-.056.456-.078a8.964 8.964 0 0 1 1.383-.102c.154 0 .309 0 .463.01.154.012.308.02.462.035a10.146 10.146 0 0 1 1.367.236 9.025 9.025 0 0 1 1.317.436 9.377 9.377 0 0 1 2.371 1.425c.12.098.236.2.35.3a10.116 10.116 0 0 1 .654.655c.104.114.2.232.3.35a9.914 9.914 0 0 1 1.026 1.537c.073.134.142.275.208.415.066.14.129.28.187.424.058.143.114.286.167.432.053.146.1.292.144.44.044.148.086.3.124.446.038.146.07.3.1.453a11.031 11.031 0 0 1 .134.916 10.18 10.18 0 0 1 .045.926c-.127 9.81-8.74 18.287-9.437 19.048Z"
        />
        <mask
            id="a"
            width={39}
            height={40}
            x={0}
            y={0}
            maskUnits="userSpaceOnUse"
            style={{
                maskType: "luminance",
            }}
        >
            <path fill="#fff" d="M38.841.611H.234v38.62h38.607V.611Z" />
        </mask>
    </svg>
);
export default AddressIcon;
